import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MFEPackageIds } from '@interfaces/open-choice/mfe-details.enum';
import { mfeResolver } from '@shared/mfe-resolver/mfe.resolver';
import * as flowGuards from '@src/app/core/guards';

import { ContactInfoComponent } from './containers/contact-info.component';

const routes: Routes = [
  {
    path: '',
    component: ContactInfoComponent,
    title: 'Your address and phone | Vanguard',
    data: {
      pageId: 'contact_info',
    },
    resolve: {
      personalAddress: mfeResolver(MFEPackageIds.PERSONAL_ADDRESS_PKG),
      phone: mfeResolver(MFEPackageIds.PHONE_PKG),
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [...flowGuards.guards],
})
export class ContactInfoRoutingModule {}
